import {DescriptionLine} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class DescriptionLineModel {
  public title: string;
  public value: string;

  constructor(params: DescriptionLineModel) {
    this.title = params.title;
    this.value = params.value;
  }

  public static fromGQL(title: string, value: string) {
    return new DescriptionLineModel({
      title,
      value,
    });
  }

  public static fromCartV1(descriptionLine: DescriptionLine) {
    return new DescriptionLineModel({
      title: descriptionLine?.name?.translated ?? descriptionLine?.name?.original,
      value: descriptionLine.colorInfo ? getColorInfoValue(descriptionLine) : getPlainTextValue(descriptionLine),
    });
  }

  /* istanbul ignore next */
  public static fromCartV2(descriptionLine: DescriptionLine): DescriptionLineModel {
    return new DescriptionLineModel({
      title: descriptionLine.name?.translated ?? descriptionLine.name?.original,
      value: descriptionLine.colorInfo ? getColorInfoValue(descriptionLine) : getPlainTextValue(descriptionLine),
    });
  }
}

const getPlainTextValue = ({plainText}: DescriptionLine) => plainText?.translated ?? plainText?.original;

const getColorInfoValue = ({colorInfo}: DescriptionLine) => colorInfo?.translated ?? colorInfo?.original;
